(function($) {

  $(document).on('submit', 'form', function() {
    const $btn = $(this).find('.btn-progress');
    if ($btn.length > 0) {
      let invalid = $(this).find('.input-validation-error').length > 0;
      invalid = invalid || !($(this).find('input, select, textarea').filter('[data-val-required]').val());

      if (!invalid) {
        $btn.addClass('btn-fill')
      }
    }
  });

})(jQuery);
